export default "__VITE_ASSET__D12pZcqh__"